import * as React from "react";
function SvgArrowDown(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M26 21L16 31 6 21M16 1v29"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowDown);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
